import { Injectable } from '@angular/core'
import { Observable } from 'rxjs';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';


@Injectable()
export class EditGridService {

  constructor(private restApiService: RestApiService) { }

  public loadGridData(url: string): Observable<{}> {
    return this.restApiService.get(url, 'page-center');
  }

  public downloadExcelGridData(url: string) {
    return this.restApiService.excel(url, 'export.xls', 'page-center');
  }

  public downloadPdfGridData(url: string) {
    return this.restApiService.pdf(url, 'print.pdf', 'page-center');
  }
}
